<template>
  <div>
    <span>Выбор игры</span>
    <v-select
      v-model="game"
      :items="games"
      class="field"
      color="accent"
      @change="choose(1)"
    />
    <br>
    <span v-if="game !== ''">
      Всего игр: {{ chooseGameStats?.matches_count }}, <br>
      Лучшый выигрыш: {{ chooseGameStats?.highest_prize }}, <br>
      Сумма ставок: {{ chooseGameStats?.bets_sum }}, <br>
      Сумма выигрышей: {{ chooseGameStats?.prizes_sum }}</span>
    <BetsTable
      v-if="game !== ''"
      :gameId="chooseGame"
      :pullFunction="choose"
      :items="chooseGameBets"
    />
    <BaseSideButtons back />
  </div>
</template>

<script>
import { getUserStatistics } from '../../api/user'
import { getStatisticsBets } from '../../api/wheel'
import { getStatisticsRounds } from '../../api/dice'
import { getStatisticsRoundsMines } from '../../api/mines'
import { getStatisticsRoundsFrutto } from '../../api/frutto'
import BetsTable from '../components/common/Table/BetsTable/BetsTable'
import BaseSideButtons from '../components/Base--SideButtons'
import { getCrashBetsStats } from '../../api/crash'

export default {
  name: 'UserStats',
  components: { BaseSideButtons, BetsTable },
  data () {
    return {
      userStats: [],
      games: ['Wheel', 'Dice', 'Mines', 'Crash', 'Frutto'],
      game: '',
      chooseGameBets: [],
      chooseGameStats: {}
    }
  },
  computed: {
    chooseGame () {
      switch (this.game) {
        case 'Wheel':
          return 0
        case 'Dice':
          return 1
        case 'Mines':
          return 2
        case 'Crash':
          return 3
        case 'Frutto':
          return 4
      }
    }
  },
  mounted () {
    this.$emit('title_changed', `Пользователь ID: ${this.$route.params.user}`)
    getUserStatistics(this.$route.params.user).then(response => {
      this.userStats = response.data
    })
  },
  methods: {
    choose (page) {
      if (this.chooseGame === 0)
        getStatisticsBets({
          user_id: this.$route.params.user,
          limit: 26,
          offset: 25 * (page - 1)
        }).then(response => {
          this.chooseGameBets = response.data.items
        })
      else if (this.chooseGame === 1)
        getStatisticsRounds({
          user_id: this.$route.params.user,
          limit: 26,
          offset: 25 * (page - 1)
        }).then(response => {
          this.chooseGameBets = response.data.items
        })
      else if (this.chooseGame === 2)
        getStatisticsRoundsMines({
          user_id: this.$route.params.user,
          limit: 26,
          offset: 25 * (page - 1)
        }).then(response => {
          this.chooseGameBets = response.data.items.map(i => {
            i.opened_cells = i.opened_cells.length
            return i
          })
        })
      else if (this.chooseGame === 3)
        getCrashBetsStats({
          user_id: this.$route.params.user,
          limit: 26,
          offset: 25 * (page - 1)
        }).then(response => {
          this.chooseGameBets = response.data.items
        })
      else if (this.chooseGame === 4)
        getStatisticsRoundsFrutto({
          user_id: this.$route.params.user,
          limit: 26,
          offset: 25 * (page - 1)
        }).then(response => {
          this.chooseGameBets = response.data.items.map(i => {
            i.opened_cells = i.opened_cells.length
            return i
          })
        })

      this.chooseGameStats = this.userStats.find(item => item.game === this.game.toLowerCase())
    }
  }
}
</script>
